import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import dashboardAnalytics from '~/analytics/dashboard/dashboardAnalytics'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import ROUTES from '~/shared/constants/routes.const'
import { selectPreviewSite } from '~/redux/slices/ui'
import { useAppSelector } from '~/redux/hooks'
import { useGetLeagueInfoForNav } from '~/hooks/useGetLeagueInfo'

export const LeagueButton = (): React.ReactElement => {
  const { t } = useTranslation('homebase')
  const router = useRouter()
  const previewSite = useAppSelector(selectPreviewSite)
  const { leagueBadgeIconUrl, userCurrentRank } = useGetLeagueInfoForNav()

  const handleClick = (): void => {
    dashboardAnalytics.handleDashboardItemViewClick('league')
    router.push(previewSite ? ROUTES.REGISTER : ROUTES.LEADERBOARD)
  }

  return (
    <button
      className="flex h-10 items-center gap-2 rounded-2.5 bg-white-dim px-4"
      data-test-id="topbar-league"
      onClick={handleClick}
    >
      <ResponsiveImage
        alt={t('leagueNavButton')}
        height={20}
        imageClassName="w-5"
        loading="eager"
        srcKey={leagueBadgeIconUrl}
        width={20}
      />
      <span className="text-base font-medium text-white">{t('leagueNavButton')}</span>
      {Boolean(userCurrentRank) && <span className="text-base font-bold text-yellow-gold">#{userCurrentRank}</span>}
    </button>
  )
}
